<template>
  <v-container>
    <v-card>
      <v-card-title>Besucherstatistik</v-card-title>
      <v-card-text>
        <v-data-table v-show="visitorStats.length>0" :headers="headers" :items="visitorStats" class="elevation-1">
        </v-data-table>
        <p v-show="visitorStats.length<=0">Keine Daten vorhanden</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

import apiMethods from '@/mixins/apiMethods.js';
export default {
  mixins:[apiMethods],
  data() {
    return {
      headers: [
        { text: 'Datum', value: 'date' },
        { text: 'Anzahl Besucher', value: 'visitors' }
      ],
      visitorStats: []
    };
  },

  methods: {
    async fetchVisitors() {
      try {
        const response = await axios.get('/visitor.php?action=get&token=' + this.token + '&format=json');
        let data=[];
        if(response && response.data && response.data.result){
          data=Object.entries(response.data.result).map(([date, visitors]) => ({ date, visitors }));
        }
        this.$set(this, 'visitorStats', data);
      } catch (error) {
        console.error('Fehler beim Abrufen der Besucherdaten:', error);
      }
    }
  },
  mounted() {
    setTimeout(()=>{
         this.fetchVisitors();
    },1000);
  }
};
</script>

<style>
.v-container {
  max-width: 800px;
  margin: auto;
}
</style>
